export default {
  namespaced: true,
  state: {
    cli: { }
  },
  
  mutations: {
    SET_ODOO_CLIENT (state, odoo) {
      state.cli = odoo
    },
    DESTROY_ODOO_CLIENT (state) {
      state.cli = { }
    }
  }
}
